import React from 'react'

import { AllMeasures } from '../types'
import { volume } from '../data/volume'
import { length } from '../data/length'
import { temperature } from '../data/temperature'
import { weight } from '../data/weight'
import { area } from '../data/area'
import { time } from '../data/time'
import { speed } from '../data/speed'
import { pressure } from '../data/pressure'
import { energy } from '../data/energy'
import { power } from '../data/power'
import { force } from '../data/force'
import { angle } from '../data/angle'
import { electricCurrent } from '../data/electricCurrent'
import { electricPotential } from '../data/electricPotential'
import { frequency } from '../data/frequency'
import { dataStorage } from '../data/dataStorage'
import { bandwidth } from '../data/bandwidth'
import { radioactiveDecay } from '../data/radioactiveDecay'
import { radioactiveEquivalentDose } from '../data/radioactiveEquivalentDose'
import { fuelConsumption } from '../data/fuelConsumption'

interface MeasureDataContextProps {
  allMeasures: AllMeasures
}

export const MeasureDataContext = React.createContext<MeasureDataContextProps>({
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  allMeasures: {} as AllMeasures
})

const allMeasures: AllMeasures = {
  length,
  speed,
  area,
  weight,
  volume,
  pressure,
  force,
  temperature,
  time,
  dataStorage,
  bandwidth,
  angle,
  frequency,
  energy,
  power,
  electricCurrent,
  electricPotential,
  fuelConsumption,
  radioactiveDecay,
  radioactiveEquivalentDose
}

interface Props {
  children: React.ReactNode
}

const MeasureDataProvider: React.FC<Props> = ({ children }) => {
  const values = {
    allMeasures
  }

  return <MeasureDataContext.Provider value={values}>{children}</MeasureDataContext.Provider>
}

export default MeasureDataProvider
